import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import SortingHeader from '../../../components/common/sorting-header';
import styles from './sticky-header.styles';

function StickyHeaderTablet({ messages }) {
  return (
    <View style={styles.rootBorderTablet}>
      <SortingHeader
        options={[
          {
            label: 'app.report.transactionHistory.tradeDate',
            key: 'tradeDate',
            width: 0.22,
            isPhone: true,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-start',
            },
          },
          {
            label: 'app.report.transactionHistory.valueDate',
            key: 'valueDate',
            width: 0.22,
            isPhone: true,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-start',
            },
          },
          {
            label: 'app.report.transactionHistory.type',
            key: 'type',
            width: 0.23,
            isPhone: true,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-start',
            },
          },
          {
            label: 'app.report.transactionHistory.securityName',
            key: 'securityName',
            width: 0.23,
            isPhone: true,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-start',
            },          
          },
          {
            label: 'app.report.transactionHistory.quantity',
            key: 'quantity',
            width: 0.235,
            isPhone: true,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-end',
            },
          },
          {
            label: 'app.report.transactionHistory.amount',
            key: 'amount',
            width: 0.195,
            isPhone: true,
            isTablet: true,
            optionStyle: {
              justifyContent: 'flex-end',
            },
          },
        ]}
        messages={messages}
      />
    </View>
  );
}

StickyHeaderTablet.propTypes = {
  showBorder: PropTypes.bool,
};

StickyHeaderTablet.defaultProps = {
  showBorder: true,
};

export default pure(StickyHeaderTablet);
